export default class CustomError extends Error {
  constructor(message, info) {
    super(typeof message === 'string' ? message : '');
    this.message = message; // preserve original value for backward compatibility
    this.info = info; // for additional information
  }
}
